import { render } from "./ComparePriceBetweenProviders.vue?vue&type=template&id=7c7a729e"
import script from "./ComparePriceBetweenProviders.vue?vue&type=script&lang=js"
export * from "./ComparePriceBetweenProviders.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__